export default __webpack_public_path__ + "static/media/ic.d4d65787.png";